export default __webpack_public_path__ + "static/media/outOfZoneIllustration.ff2411f2.png";